import { Directive, ElementRef, HostListener, Input } from "@angular/core";
import { ShapeInput } from "../../shape/shape.model";

interface ImageResizerOptions {
  coordinates: ShapeInput[]; // Coordinates to overlay
  lengthArr: {l1: number, l2: number, l3: number, l4: number, l5: number, l6: number}
}

@Directive({
  selector: "[appImageDrawer]",
})
export class ImageDrawerDirective {
  @Input('appImageDrawer') drawOptions: ImageResizerOptions;

  constructor(private elementRef: ElementRef) {}
  @HostListener("load", ["$event.target"])
  onImageLoad(image: HTMLImageElement) {
    const targetWidth = 90;
    const targetHeight = 90;
    
    // Increase canvas resolution for better quality (2x for high DPI displays)
    const scaleFactor = 2;
    const canvasWidth = targetWidth * scaleFactor;
    const canvasHeight = targetHeight * scaleFactor;

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    canvas.style.width = targetWidth + 'px';
    canvas.style.height = targetHeight + 'px';

    if(context){
      // Enable image smoothing for better quality
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = 'high';
      
      context.clearRect(0, 0, canvasWidth, canvasHeight);
      
      // Draw the image at higher resolution
      context.drawImage(image, 0, 0, canvasWidth, canvasHeight);

      // Set text properties for better quality
      context.fillStyle = 'red';
      context.textBaseline = 'middle';
      context.textAlign = 'center';
      
      this.drawOptions.coordinates.forEach((coord, index) => {        
        const x = ((index % 5) * 75) + coord.position.x + 10;
        const y = (index > 4 ? 35 : 0) + coord.position.y + 30;
        
        // Scale coordinates for high resolution canvas
        const scaledX = x * 0.225 * scaleFactor;
        const scaledY = y * 0.225 * scaleFactor;
        
        context.fillStyle = 'red';
        context.font = `bold ${9 * scaleFactor}px Arial`; // Scale font size
        context.fillText(this.getLength(coord.name), scaledX, scaledY);
      });
    }
    
    // Convert the canvas to an image with higher quality
    const dataURL = canvas.toDataURL("image/png", 1.0); // Maximum quality
    const newImage = new Image();
    newImage.src = dataURL;
    newImage.width = targetWidth;
    newImage.height = targetHeight;
    
    if(image.parentNode)
    image.parentNode.replaceChild(newImage, image);
  }

  getLength(name: string): string {
    if(!(this.drawOptions && this.drawOptions.lengthArr)) return '';
    switch(name) {
      case 'A' : return this.drawOptions.lengthArr.l1 ? (Math.floor(this.drawOptions.lengthArr.l1 * 1000)).toString() : '-';
      case 'B' : return this.drawOptions.lengthArr.l2 ? (Math.floor(this.drawOptions.lengthArr.l2 * 1000)).toString() : '-';
      case 'C' : return this.drawOptions.lengthArr.l3 ? (Math.floor(this.drawOptions.lengthArr.l3 * 1000)).toString() : '-';
      case 'D' : return this.drawOptions.lengthArr.l4 ? (Math.floor(this.drawOptions.lengthArr.l4 * 1000)).toString() : '-';
      case 'E' : return this.drawOptions.lengthArr.l5 ? (Math.floor(this.drawOptions.lengthArr.l5 * 1000)).toString() : '-';
      case 'F' : return this.drawOptions.lengthArr.l6 ? (Math.floor(this.drawOptions.lengthArr.l6 * 1000)).toString() : '-';
      default: return '';
    }
  }
}
